"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.contentCategoryStencilDefinition = void 0;
const properties_1 = require("../properties");
exports.contentCategoryStencilDefinition = {
    view: {
        label: 'Custom tag',
        category: 'tag',
        group: 'Taxonomy',
        titleItems: ['title'],
        imageItems: [],
        contentAreas: [
            {
                name: 'main',
                items: ['title'],
            },
            {
                name: 'info',
                subAreas: [
                    {
                        name: 'General',
                        items: [
                            'preferred-label',
                            'seo-title',
                            'social-title',
                            'featured-title',
                            'alternative-labels',
                        ],
                    },
                    {
                        name: 'Settings',
                        items: ['standalone'],
                    },
                    {
                        name: 'Custom Properties',
                        items: ['properties-container'],
                    },
                ],
            },
            {
                name: 'tagging',
                items: ['broader-content-category', 'related-content'],
            },
        ],
    },
    content: {
        'alternative-labels': properties_1.alternativeLabelsPropertyDefinition,
        'broader-content-category': properties_1.broaderContentCategoryPropertyDefinition,
        'featured-title': properties_1.featuredTitlePropertyDefinition,
        'preferred-label': properties_1.preferredLabelPropertyDefinition,
        'properties-container': properties_1.propertiesContainerPropertyDefinition,
        'related-content': properties_1.relatedContentPropertyDefinition,
        'seo-title': properties_1.seoTitlePropertyDefinition,
        'social-title': properties_1.socialTitlePropertyDefinition,
        standalone: {
            ...properties_1.standalonePropertyDefinition,
            default: true,
        },
        title: properties_1.titlePropertyDefinition,
    },
    localizations: ['en'],
    roles: ['taxonomy-manager'],
    spaces: [
        'batalla',
        'brand-building-events',
        'erc',
        'global',
        'media-partnerships',
        'organics',
        'organics-mixed-consumption',
        'pro-cycling',
        'racing-bulls',
        'rb-juniorteam',
        'rb-rookies',
        'rbtv',
        'rbtv_temporary',
        'redbull-f1academy',
        'redbull-powertrains',
        'redbull-racing',
        'redbull-simracing',
        'redbull_com',
        'redbulletin',
        'redbullmusic',
        'wingfinder',
        'wrc',
        'xalps',
    ],
    name: 'content-category',
};
const isContentCategoryStencil = (stencil) => {
    return stencil.name === exports.contentCategoryStencilDefinition.name;
};
//# sourceMappingURL=data:application/json;base64,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